const initCartQuantity = (): void => {
  const cartForm = document.querySelector<HTMLFormElement>('[data-cart-form]');
  if (!cartForm) return;
  const qtyInputEls = cartForm.querySelectorAll<HTMLInputElement>('[data-qty-input]');
  const cartUpdateBtn = cartForm.querySelector<HTMLInputElement>('[data-cart-update]');

  const onQtyInputChange = (input: HTMLInputElement): void => {
    const lineItemQtyInput = input.closest('[data-cart-item]')?.querySelector<HTMLInputElement>('[data-cart-item-qty]');
    if (lineItemQtyInput) {
      lineItemQtyInput.value = input.value;
      cartUpdateBtn?.classList.remove('hidden');
    }
  };

  qtyInputEls.forEach((input: HTMLInputElement): void => {
    input.addEventListener('change', (): void => {
      onQtyInputChange(input);
    });
  });
};

export default initCartQuantity;
